import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSubscription } from '@/hooks/useSubscription';
import { useEffect, useState } from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

export function TrialNotification() {
  const { subscriptionInfo } = useSubscription();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    console.log('TrialNotification - Subscription state:', {
      tier: subscriptionInfo.tier,
      remainingDays: subscriptionInfo.remainingTrialDays,
      isTrialExpired: subscriptionInfo.isTrialExpired
    });
    
    // Only show notification if user is on free trial and has remaining days
    if (subscriptionInfo.tier === 'free_trial' && subscriptionInfo.remainingTrialDays > 0) {
      console.log('User is on free trial with', subscriptionInfo.remainingTrialDays, 'days remaining');
      // Check if we've shown this notification before
      const hasSeenNotification = localStorage.getItem('hasSeenTrialNotification');
      console.log('Has seen notification before?', hasSeenNotification);
      if (!hasSeenNotification) {
        console.log('Showing trial notification');
        setIsOpen(true);
        localStorage.setItem('hasSeenTrialNotification', 'true');
      }
    }
  }, [subscriptionInfo.tier, subscriptionInfo.remainingTrialDays, subscriptionInfo.isTrialExpired]);

  if (!isOpen || subscriptionInfo.tier !== 'free_trial' || subscriptionInfo.remainingTrialDays <= 0) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md">
      <Alert className="bg-white shadow-lg">
        <div className="flex justify-between items-start">
          <div>
            <AlertTitle className="text-lg font-semibold">🎉 Free Trial Active</AlertTitle>
            <AlertDescription className="mt-2">
              You have {subscriptionInfo.remainingTrialDays} day{subscriptionInfo.remainingTrialDays !== 1 ? 's' : ''} 
              left in your free trial. Enjoy full access to all features!
            </AlertDescription>
          </div>
          <Button
            variant="ghost"
            size="icon"
            className="h-6 w-6 -mt-2 -mr-2"
            onClick={() => setIsOpen(false)}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </Alert>
    </div>
  );
}
